import React from 'react';
import { motion } from 'framer-motion';
export function MockupSection() {
  return <section className="w-full px-6 py-5 pb-8 max-w-4xl mx-auto text-center" data-id="element-21">
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      delay: 0.4
    }} data-id="element-22">
        <a href="https://antipantalla.narelaspace.com" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#1B2A4A] text-[#C4A265] hover:bg-[#15203a] hover:scale-[1.02] transition-all duration-300 px-8 py-4 rounded-full text-lg font-semibold shadow-lg shadow-[#1B2A4A]/20 no-underline" data-id="element-23">
          Ver como funciona el plan
        </a>
      </motion.div>
    </section>;
}